'use client';

import RouteError from '@/shared/components/error/RouteError';

/**
 * Dashboard Layout Error Boundary
 *
 * Catches errors that occur anywhere within the (dashboard) route group.
 * This is the last line of defense for dashboard-related errors.
 */
export default function DashboardError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteError error={error} reset={reset} />;
}
